import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {
    returnPurchaseAddItemAsync,
    returnPurchaseChangeEmployeeAsync, returnPurchaseUpdateNoteAsync,
    selectReturnPurchaseDefaultsSettings
} from "../../../../../store/reducers/warehouse/returnPurchase";
import {selectWarehouses} from "../../../../../store/reducers/warehouse/warehouseReducer";
import {selectLang} from "../../../../../store/reducers/main/main";
import {selectDefaultSetting} from "../../../../../store/reducers/settings/settingsReducer";
import {Translate} from "../../../../../lang/lang";
import {selectCurrency} from "../../../../../store/reducers/currency/currencyReducer";
import {FormProvider, useForm} from "react-hook-form";
import dayjs from "dayjs";
import {UZS} from "../../../../../enum/item/itemWrapper";
import toast from "react-hot-toast";
import ReturnPurchaseForm from "./ReturnPurchaseForm";
import {Form} from "react-bootstrap";

const EditReturnPurchaseForm = ({returnPurchase}) => {

    const returnPurchaseDefaultsSettings = useSelector(selectReturnPurchaseDefaultsSettings)
    const [loading, setLoading] = useState(false)
    const warehouses = useSelector(selectWarehouses)
    const currencies = useSelector(selectCurrency)
    const lang = useSelector(selectLang)
    const t = Translate
    const settings = useSelector(selectDefaultSetting)

    const form = useForm({
        defaultValues: {
            contractor_id: returnPurchase?.contractor?.id,
            employee_id: returnPurchase?.employee?.id,
            date: dayjs(returnPurchase?.date, "YYYY-MM-DD HH:mm").toDate(),
            note: returnPurchase?.note,
            number: returnPurchase?.number,
            item_id: null,
            warehouse_id: settings?.warehouse?.default_id || null,
            quantity: null,
            marks: [],
            commonPrice: {
                amount: null,
                currency_id: currencies?.find(c => c?.code === UZS)?.id,
            },
        }
    })

    const resetForm = (formData) => {
        form.reset({
            contractor_id: formData?.contractor_id,
            employee_id: formData?.employee_id,
            date: formData?.date && dayjs(formData?.date, "YYYY-MM-DD HH:mm").toDate(),
            note: formData?.note,
            number: formData?.number,
            item_id: null,
            quantity: null,
            warehouse_id: settings?.warehouse?.default_id || null,
            warehouse: warehouses,
            package_measurements: null,
            marks: [],
            commonPrice: {
                amount: '0',
                currency_id: currencies?.find(c => c?.code === UZS)?.id,
            },
        })
    }

    const onSubmit = async (formData, event) => {
        const buttonType = event?.nativeEvent?.submitter?.name
        const quantity = +formData?.quantity * +formData?.package_measurements?.quantity

        const item = {
            item_id: formData?.item_id,
            warehouse_id: formData?.warehouse_id,
            quantity: quantity,
            marks: formData?.marks || [],
            price: {
                amount: +formData?.commonPrice?.amount,
                currency_id: formData?.commonPrice?.currency_id,
            },
        }


        if (buttonType === "addOrEditReturnPurchase" || event === "addOrEditReturnPurchase") {
            setLoading(true)
            /* if (returnPurchase?.contractor?.id !== formData?.contractor_id) {
                 await returnPurchaseChangeContractorAsync({returnPurchaseId: returnPurchase.id, contractorId: formData?.contractor_id})
                     .then(({data}) => {
                     })
                     .catch(() => {})
                     .finally(() => {
                         setLoading(false)
                     })
             }*/

            await returnPurchaseAddItemAsync({
                returnPurchaseId: returnPurchase?.id,
                operation: item
            })
                .then(({data}) => {
                    updateNote(formData)
                    // updateNumber(formData)
                    resetForm(formData)
                    updateEmployee(formData)
                    toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                })
                .catch((error) => {
                    if (error?.response?.data?.includes("warehouse")) {
                        toast.error(t(lang, "Склад не выбран"))
                    } else {
                        toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                    }
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }

    const updateEmployee = (formData) => {
        if (formData?.employee_id || returnPurchase?.employee) {
            if (formData?.employee_id !== returnPurchase?.employee?.id) {
                returnPurchaseChangeEmployeeAsync({returnPurchaseId: returnPurchase?.id, employeeId: formData?.employee_id})
                    .then(() => { })
                    .catch(() => {})
            }
        }
    }

    const updateNote = (formData) => {
        if (formData?.note !== returnPurchase?.note) {
            returnPurchaseUpdateNoteAsync({returnPurchaseId: returnPurchase?.id, note: formData?.note})
                .then(({data}) => {})
                .catch(() => {})
        }
    }

    return (
        <FormProvider {...form}>
            <Form onSubmit={form.handleSubmit(onSubmit)}>
                <ReturnPurchaseForm returnPurchase={returnPurchase} loading={loading} addItem={form.handleSubmit(onSubmit)} isEditing={true}/>
            </Form>
        </FormProvider>
    );
};

export default EditReturnPurchaseForm;
